import * as inspectionActions from './actions';

import { put, retry, select, takeLatest } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';
import { InspectionResolvedResponse } from '../../features/AssetGrid/types/inspection.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { getAssetIdAndType } from '../../features/AssetGrid/utils/helpers';
import { getInspections } from '../../services/inspection';
import { selectInspectionsByAssetId } from './selectors';

function* getInspectionsSaga(action: PayloadAction<string>) {
	// check if inspections have already been retrieved before requesting
	const inspections: ReturnType<typeof selectInspectionsByAssetId> = yield select(
		(state: Parameters<typeof selectInspectionsByAssetId>[0]) =>
			selectInspectionsByAssetId(state, action.payload),
	);
	if (inspections) return;
	const {
		getInspectionsResolved,
		getInspectionsRejected,
	} = inspectionActions;
	const { assetId } = getAssetIdAndType(action.payload);
	try {
		const payload: AxiosResponse<InspectionResolvedResponse> = yield retry(
			5,
			1500,
			getInspections,
			assetId,
		);
		if (payload.data) {
			yield put(
				getInspectionsResolved({
					assetId: action.payload,
					inspections: payload.data.data,
				}),
			);
		} else {
			yield put(getInspectionsRejected());
		}
	} catch (e) {
		yield put(getInspectionsRejected());
	}
}

function* watchGetInspections() {
	yield takeLatest(inspectionActions.getInspections, getInspectionsSaga);
}

export default [watchGetInspections()];
